import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Gallery from './Gallery';
import { Helmet } from "react-helmet";

class GalleryPage extends React.Component {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        const artworks = this.props.artworks;
        const loading = this.props.loading;

        return (
            <div className="gallery-page">
                <Helmet>
                    <title>Gallery | Ailsa Lyn Artist</title>
                    <meta name="description" content="A collection of my recent work including collages, watercolours and drawings." />
                    <meta property="og:title" content="Ailsa Lyn Artist - Gallery" />
                    <meta property="og:url" content="https://ailsalyn.co.uk/gallery" />
                    <meta property="og:description" content="A collection of my recent work including collages, watercolours and drawings." />
                </Helmet>
                {artworks.length > 0 && !loading && < Gallery artworks={artworks} />}
                {loading &&
                    <div className="text-center loading">
                        <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
                        <span className="sr-only">Loading...</span>
                    </div>
                }
            </div>
        );
    }
}

GalleryPage.propTypes = {
    artworks: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
    return {
        artworks: state.artworks,
        loading: state.ajaxCallsInProgress > 0,
    };
}

export default connect(
    mapStateToProps
)(GalleryPage);



// WEBPACK FOOTER //
// ./src/components/gallery/GalleryPage.js